// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__3Zmpi","icon":"styles_icon__5_fs9","des":"styles_des__93Gii"};